import React, { useState, useEffect } from "react";
import "../CSS/Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { FaBars, FaTimes } from "react-icons/fa";

export default function Navbar() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Ambil ADMIN dari localStorage (tetap disimpan ke variabel user)
  useEffect(() => {
    const storedAdmin = JSON.parse(localStorage.getItem("admin"));
    setUser(storedAdmin);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("admin"); // hapus session login admin
    setUser(null);
    navigate("/");
    window.location.reload(); // supaya navbar update
  };

  return (
    <header className="tk-navbar">
      <div className="navbar-left">
      {/* Logo */}
      <div className="tk-brand">
        <img
          src={process.env.PUBLIC_URL + "/assets/logobaruTibiSmart.png"}
          alt="TibiSmart"
          className="tk-logo"
        />
      </div>

      {/* Hamburger  */}
      <button
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      </div>

      {/* Menu Navigasi */}
      <nav className={`nav-left ${menuOpen ? "open" : ""}`}>
        

        <a href="#about" onClick={() => setMenuOpen(false)}>
          About
        </a>

        <a href="#help" onClick={() => setMenuOpen(false)}>
          Help
        </a>

        <a href="#contact" onClick={() => setMenuOpen(false)}>
          Contact
        </a>

        {user ? (
          <Link
            to="/HalamanRingkasanAnalitikAdmin"
            onClick={() => setMenuOpen(false)}
          >
            <button className="tk-dashboard-btn">Home</button>
          </Link>
        ) : (
          <Link
            to="/loginadmin"
            onClick={() => setMenuOpen(false)}
          >
            <button className="tk-login-btn">Log In</button>
          </Link>
        )}
      </nav>

      {/* Profil Admin */}
      {user && (
        <div
          className="navbar-user"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <span className="username">
            {user.username_admin}
          </span>

          <FaUserCircle className="profile-icon" size={35} />

          {showDropdown && (
            <div className="dropdown-menu">
              <button onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
